export const environment = {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  appVersion: require('../../package.json').version,
  newVersionPolingInterval: 'PT10M',
  production: true,
  locales: ['en'],
  defaultLocale: 'en',
  commitId: '9893a5e'
};
